import React from 'react'
import clsx from 'clsx'

export const AdminTable = ({ className, children }) => (
  <table className={clsx(className, 'table-auto border border-gray-200')}>{children}</table>
)

export const AdminTd = ({ className, children }) => (
  <td className={clsx(className, 'px-4 border border-gray-200 text-lg text-gray-600')}>{children}</td>
)

export const AdminTh = ({ className, children }) => (
  <th className={clsx(className, 'px-4 border border-gray-200 bg-gray-100 text-xs text-gray-600 text-left')}>
    {children}
  </th>
)
